module.exports = __webpack_public_path__ + "static/media/lv_ru_mob_r.ef363816.png";